import React, { useEffect, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import ProSVGIcons from './ProSVGIcons'
import Button from './Button'
import { useLanguage } from '../../hooks/useLanguage'


const ProPrivacy = () => {
  const { lang } = useLanguage()

  return (
    <>

      {lang === 'EN' ? <div className='m-8 md:max-w-3xl lg:max-w-4xl mx-auto xl:text-lg px-6'>
        <h1 className='my-4 border-b-2 pb-3 text-4xl'>Cookie Policy</h1>
        <p className='my-4'>At 1F8 Corporation (hereinafter referred to as &quot;the Company&quot;), we use cookies and similar technologies to collect certain information for the following purposes.</p>
        <ol>
          <li>To analyze customer usage of our website</li>
          <li>To provide more customized services and advertisements to individual customers</li>
        </ol>
        <p className='my-4'>This Cookie Policy explains cookies and similar technologies used for these purposes, the detailed purposes of use, and how to refuse (opt-out) cookies and similar technologies.</p>

        <h2 className='text-2xl mb-4'>1. About Cookies and Similar Technologies</h2>
        <p className='my-4'>A &quot;cookie&quot; is a small text file that is sent from a web server to the browser on your computer or mobile device (collectively referred to as &quot;device&quot;) when you access a website, and is stored on your device&#39;s hard disk drive. Cookies are generally categorized into two types: &quot;1st Party Cookies&quot; and &quot;3rd Party Cookies&quot;.</p>

        <h3 className='text-lg'>1.1 1st Party Cookies</h3>
        <p className='my-4'>&quot;1st Party Cookies&quot; are set by the Company. These cookies are generally set to utilize the functions provided on our website, and refusing to use them may cause the website to malfunction.</p>

        <h3 className='text-lg'>1.2 3rd Party Cookies</h3>
        <p className='my-4'>&quot;3rd Party Cookies&quot; are set by third parties (3rd Party) with whom the Company cooperates. For example, some 3rd Party Cookies are set by advertising service providers with whom we partner to track your browsing activity and place appropriate online advertisements in the right places.</p>

        <h3 className='text-lg'>1.3 Beacons (or Pixels)</h3>
        <p className='my-4'>A &quot;beacon&quot; (or &quot;pixel&quot;) is a technology that transfers information from your device to a server. Beacons can be embedded in online content such as videos and images, or in emails, allowing the server to read specific types of information from your device, recognize when you have viewed certain content or opened/previewed emails, and record viewing times and device IP addresses.</p>

        <h2 className='text-2xl mb-4'>2. Purposes of Using Cookies and Similar Technologies</h2>
        <h3 className='text-lg'>(1) Use of Cookies for Service Utilization</h3>
        <p className='my-4'>Among the aforementioned cookies, 1st Party Cookies are generally used to automatically identify your device when you browse the internet or use certain web services, allowing you to continue using the service from where you left off without repeatedly entering the same information.</p>

        <h3 className='text-lg'>(2) Use of Cookies and Similar Technologies for Analyzing Usage Conditions</h3>
        <p className='my-4'>At Vector Group, we use the information collected through cookies and similar technologies to analyze the usage conditions of our website (access status, traffic, routing, etc.), improve the performance of the website itself, and enhance and improve the services provided to customers through the website. In this case, 3rd Party Cookies set by analytics service providers are used to analyze access conditions, etc.</p>

        <p className='my-4'>The following tools are mainly used for this analysis, and the information mentioned above is also provided to the tool providers and may be used for advertising purposes.</p>

        <p className='my-4'>① Google Analytics<br />
          ・Tool Provider: Google Inc.<br />
          ・<a className='text-blue-700' href='https://www.google.com/analytics/terms/jp.html'>Google Analytics Terms of Service</a><br />
          ・<a className='text-blue-700' href='https://policies.google.com/privacy'>Google Privacy Policy</a><br />
          ・Information collected through the tool: Usage conditions of your website (access status, traffic, routing, etc.)</p>

        <p className='my-4'>For information on how to stop providing information to these tools, please see &quot;3. Methods to Refuse Cookies and Similar Technologies&quot;.</p>

        <h3 className='text-lg'>(3) Use of Cookies for Advertising Distribution</h3>
        <p className='my-4'>3rd Party Cookies are also used to track your browsing activities and display appropriate advertisements on your browser. By accessing our website, 3rd Party Cookies are sent from the advertising service providers mentioned in the following sections. The 1st Party Cookies sent by the Company, along with the 3rd Party Cookies sent by each advertising service provider, are stored on the servers of each advertising service provider and are handled in accordance with their respective privacy policies. Please see the following sections for methods to stop behaviorally targeted advertising.</p>

        <h2 className='text-2xl mb-4'>3. Methods to Refuse Cookies and Similar Technologies</h2>
        <h3 className='text-lg'>(1) How to Refuse All Cookies</h3>
        <p className='my-4'>Cookies on your device will remain until you delete them yourself or until they expire. Most browsers are set to automatically accept cookies by default, but you can change your browser settings to disable cookies. However, if you disable cookies, some website functions may not work properly, and some pages may not display correctly in relation to the use of service-related cookies.</p>
        <p className='my-4'>For information on common browsers and how to change cookie settings, please refer to the following links.</p>
        <ul>
          <li>・<a className='text-blue-700' href='https://support.apple.com/ja-jp/guide/safari/sfri11471/mac'>Apple Safari</a></li>
          <li>・<a className='text-blue-700' href='https://support.google.com/chrome/answer/95647?hl=ja'>Google Chrome</a></li>
          <li>・<a className='text-blue-700' href='https://support.microsoft.com/ja-jp/help/17442/windows-internet-explorer-delete-manage-cookies'>Microsoft Internet Explorer</a></li>
          <li>・<a className='text-blue-700' href='https://support.microsoft.com/ja-jp/microsoft-edge'>Microsoft Edge</a></li>
          <li>・<a className='text-blue-700' href='https://support.mozilla.org/ja/kb/enable-and-disable-cookies-website-preferences'>Mozilla Firefox</a></li>
        </ul>

        <h3 className='text-lg mt-4'>(2) How to Refuse Specific Cookies</h3>
        <p className='my-4'>Methods to stop providing information to the tools mentioned in (2) of the previous section are described at the links provided below. However, please note that if you delete all this cookie (3rd Party Cookie) information, there may be restrictions on the use of the products and services provided by each company.</p>

        <table className='min-w-full bg-white border border-gray-200'>
          <thead>
            <tr className='bg-gray-100 border-b'>
              <th className='py-2 px-4 border-r'>Main Tool Providers</th>
              <th className='py-2 px-4 border-r'>Privacy Policy</th>
              <th className='py-2 px-4'>Method to Stop Information Provision</th>
            </tr>
          </thead>
          <tbody>
            <tr className='border-b'>
              <td className='py-2 px-4 border-r'>Google Inc</td>
              <td className='py-2 px-4 border-r'><a className='text-blue-700' href='https://policies.google.com/privacy'>Google Privacy Policy</a></td>
              <td className='py-2 px-4'><a className='text-blue-700' href='https://tools.google.com/dlpage/gaoptout'>Google Analytics Opt-out Add-on</a></td>
            </tr>
          </tbody>
        </table>
        <p className='my-4'>For behaviorally targeted advertising mentioned in (3) of the previous section, the URLs of the advertising service providers listed below contain methods to stop the distribution. However, please note that if you delete all this cookie information, there may be restrictions on the use of the products and services provided by each company. Furthermore, for Facebook Japan Co., Ltd., among the advertising service providers listed below, if you are a registered user of the company, your browsing history will be managed in conjunction with your registration information.</p>

        <table className='min-w-full bg-white border border-gray-200'>
          <thead>
            <tr className='bg-gray-100 border-b'>
              <th className='py-2 px-4 border-r'>Main Advertising Service Providers</th>
              <th className='py-2 px-4 border-r'>Privacy (Cookie) Policy</th>
              <th className='py-2 px-4'>Method to Stop Information Provision</th>
            </tr>
          </thead>
          <tbody>
            <tr className='border-b'>
              <td className='py-2 px-4 border-r'>Google LLC and Google Network</td>
              <td className='py-2 px-4 border-r'><a className='text-blue-700' href='https://policies.google.com/privacy'>Google Privacy Policy</a></td>
              <td className='py-2 px-4'><a className='text-blue-700' href='https://support.google.com/ads/answer/2662922?hl=ja'>Block Specific Ads</a></td>
            </tr>
          </tbody>
        </table>
      </div>
        :
        <div className='m-8 md:max-w-3xl lg:max-w-4xl mx-auto xl:text-lg px-6'>
          <h1 className='my-4 border-b-2 pb-3 text-4xl'>Cookieポリシー</h1>
          <p className='my-4'>株式会社1F8（以下「当社」といいます）では、以下の目的のためにCookieおよび類似技術を使用して一定の情報を収集します。</p>
          <ol>
            <li>・ウェブサイトにおけるお客様の利用状況の分析</li>
            <li>・個々のお客様に対してよりカスタマイズされたサービス・広告の提供</li>
          </ol>
          <p className='my-4'>本Cookieポリシーでは、これらの利用目的のためのCookieおよび類似技術の説明をした上で、利用目的の詳細な説明、Cookieおよび類似技術についての拒否方法（オプトアウト）について説明します。</p>

          <h2 className='text-2xl mb-4'>1. Cookieおよび類似技術について</h2>
          <p className='my-4'>「Cookie」とは、お客様がウェブサイトにアクセスした時に、ウェブサーバからお客様のコンピューターまたはモバイルデバイス（以下、あわせて「デバイス」といいます）のブラウザに送信され、デバイスのハードディスクドライブに保存される小さなテキストファイルです。Cookieは、一般的に「1st Party Cookie（ファーストパーティクッキー）」と「3rd Party Cookie（サードパーティクッキー）」という2種類のカテゴリーに大別されます。</p>

          <h3 className='text-lg'>1.1 1st Party Cookie</h3>
          <p className='my-4'>「1st Party Cookie」は、当社によって設定されます。このCookieは、ほとんどの場合、当社ウェブサイト上で提供される機能を利用するために設けられており、利用を拒否したすると、ウェブサイトが正常に機能しない場合があります。</p>

          <h3 className='text-lg'>1.2 3rd Party Cookie</h3>
          <p className='my-4'>「3rd Party Cookie」は、当社ではなく、当社が提携する第三者（3rd Party）によって設定されます。例えば、3rd Party Cookieの一部は、当社が提携する広告配信サービス提供会社によって、適切なオンライン広告を適切な場所に掲載することができるようお客様のブラウジング活動を追跡するために設定されることがあります。</p>

          <h3 className='text-lg'>1.3 ビーコン（またはピクセル）</h3>
          <p className='my-4'>「ビーコン（またはピクセル）」とは、お客様のデバイスからサーバへ情報を転送する技術の一つです。ビーコンは、動画や静止画等のオンラインコンテンツや電子メールに埋め込むことができ、これによってサーバはお客様のデバイスから特定の種類の情報を読み取り、お客様が特定のコンテンツを閲覧したり、電子メールを開封/プレビューしたりしたことを認識の上、閲覧日時やデバイスのIPアドレスなどの情報を記録します。</p>

          <h2 className='text-2xl mb-4'>2. Cookieおよび類似技術の利用目的</h2>
          <h3 className='text-lg'>(1) サービス利用のためのCookieの利用</h3>
          <p className='my-4'>上述のCookieのうち、1st Party Cookieは、一般的にお客様がインターネット閲覧を行う際、または特定のウェブサービスを利用する際に、自動的にお客様のデバイスを識別し、お客様が同じ情報を繰り返し入力することなく、前回の続きとしてサービスを利用できるために用いられています。</p>

          <h3 className='text-lg'>(2) アクセス状況等の解析等のためのCookieおよび類似技術の利用</h3>
          <p className='my-4'>ベクトルグループでは、Cookieおよび類似技術を使用して収集した情報を利用して、お客様のウェブサイトの利用状況（アクセス状況、トラフィック、ルーティング等）を分析し、ウェブサイト自体のパフォーマンス改善や、ウェブサイトを通じてベクトルグループからお客様に提供するサービスの向上、改善のために使用することがあります。この場合のCookieは、アクセス状況等を解析する事業者から設定される3rd Party Cookieが用いられます。</p>

          <p className='my-4'>この分析にあたっては主に以下のツールが利用されますが、ツール提供者にも上記の情報が提供され、お客様に対する広告配信等に利用されることがあります。</p>

          <p className='my-4'>① Google Analytics<br />
            ・ツール提供者: Google Inc.<br />
            ・<a className='text-blue-700' href='https://www.google.com/analytics/terms/jp.html'>Google Analytics利用規約</a><br />
            ・<a className='text-blue-700' href='https://policies.google.com/privacy'>Googleプライバシーポリシー</a><br />
            ・ツールを通して収集される情報：お客様のウェブサイトの利用状況（アクセス状況、トラフィック、ルーティング等）</p>

          <p className='my-4'>これらのツールへの情報提供を停止するための方法については、「3.Cookieおよび類似技術の拒否方法」をご確認ください。</p>

          <h3 className='text-lg'>(3) 広告配信のためのCookieの利用</h3>
          <p className='my-4'>3rd Party Cookieはお客様のブラウジング活動を追跡し、お客様のブラウザの表示画面に適切な広告を表示するためにも用いられています。当社ウェブサイトにアクセスすることにより、次条の広告配信サービス提供会社から3rd Party Cookieが送信されます。当社が送信する1st Party Cookieは、各広告配信サービス提供会社が送信する3rd Party Cookieと共にそれぞれの広告配信サービス提供会社のサーバに保存され、それぞれのプライバシーポリシーに従って取り扱われます。行動ターゲティング広告の配信停止方法等については、次条をご確認ください。</p>

          <h2 className='text-2xl mb-4'>3. Cookieおよび類似技術の拒否方法</h2>
          <h3 className='text-lg'>(1) 全てのCookieを拒否する方法</h3>
          <p className='my-4'>お客様のデバイス上のCookieは、お客様が自ら削除されるか、または一定の有効期限が切れるまでデバイスに残ります。ほとんどのブラウザではデフォルトで自動的にCookieの受け入れを有効にしていますが、お客様がブラウザの設定を変更することによりCookieを無効にすることが可能です。ただし、Cookieを無効にした場合、サービス利用のためのCookieの利用との関係では、一部のウェブサイトの機能が使用できなくなったり、一部のページが正しく表示されなくなる場合がありますのでご留意ください。</p>
          <p className='my-4'>一般的に普及しているブラウザについての情報と、Cookieの設定の変更方法については、以下のリンク先をご参照ください。</p>
          <ul>
            <li>・<a className='text-blue-700' href='https://support.apple.com/ja-jp/guide/safari/sfri11471/mac'>Apple Safari</a></li>
            <li>・<a className='text-blue-700' href='https://support.google.com/chrome/answer/95647?hl=ja'>Google Chrome</a></li>
            <li>・<a className='text-blue-700' href='https://support.microsoft.com/ja-jp/help/17442/windows-internet-explorer-delete-manage-cookies'>Microsoft Internet Explorer</a></li>
            <li>・<a className='text-blue-700' href='https://support.microsoft.com/ja-jp/microsoft-edge'>Microsoft Edge</a></li>
            <li>・<a className='text-blue-700' href='https://support.mozilla.org/ja/kb/enable-and-disable-cookies-website-preferences'>Mozilla Firefox</a></li>
          </ul>

          <h3 className='text-lg mt-4'>(2) 特定のCookieを拒否する方法</h3>
          <p className='my-4'>前条(2)項に記載するツールへの情報提供を停止するための方法は以下に記載するリンク先にそれぞれ記載されています。ただし、これらのCookie（3rd Party Cookie）情報をすべて削除した場合には、各社が提供する製品やサービスを活用するうえでの制約を受けることがあることにご留意ください。</p>

          <table className='min-w-full bg-white border border-gray-200'>
            <thead>
              <tr className='bg-gray-100 border-b'>
                <th className='py-2 px-4 border-r'>主なツール提供会社</th>
                <th className='py-2 px-4 border-r'>プライバシーポリシー</th>
                <th className='py-2 px-4'>情報送信停止の方法</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border-b'>
                <td className='py-2 px-4 border-r'>Google Inc</td>
                <td className='py-2 px-4 border-r'><a className='text-blue-700' href='https://policies.google.com/privacy'>Googleプライバシーポリシー</a></td>
                <td className='py-2 px-4'><a className='text-blue-700' href='https://tools.google.com/dlpage/gaoptout'>Google アナリティクスオプトアウトアドオン</a></td>
              </tr>
            </tbody>
          </table>
          <p className='my-4'>前条(3)項に記載する行動ターゲティング広告に関しては、以下に記載する広告配信サービス提供会社のURLに配信停止の方法が記載されています。ただし、これらのCookie情報をすべて削除した場合には、各社が提供する製品やサービスを活用するうえでの制約を受けることがあることにご留意ください。なお、以下の広告配信サービス提供会社のうち、フェイスブックジャパン株式会社につきましては、お客様が同社の登録ユーザーである場合には、ウェブサイトの閲覧履歴は、お客様の登録情報に紐づく形で管理されることになります。</p>

          <table className='min-w-full bg-white border border-gray-200'>
            <thead>
              <tr className='bg-gray-100 border-b'>
                <th className='py-2 px-4 border-r'>主な広告配信サービス提供会社</th>
                <th className='py-2 px-4 border-r'>プライバシー（Cookie）ポリシー</th>
                <th className='py-2 px-4'>情報送信停止の方法</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border-b'>
                <td className='py-2 px-4 border-r'>グーグル合同会社およびGoogleネットワーク</td>
                <td className='py-2 px-4 border-r'><a className='text-blue-700' href='https://policies.google.com/privacy'>Googleプライバシーポリシー</a></td>
                <td className='py-2 px-4'><a className='text-blue-700' href='https://support.google.com/ads/answer/2662922?hl=ja'>特定の広告のブロック</a></td>
              </tr>
            </tbody>
          </table>
        </div>}
    </>
  )

}


export default ProPrivacy




